var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTooltip)?_c('div',{ref:"popper",staticClass:"tooltip"},[_c('div',{staticClass:"tooltip-inner text-justify"},[_vm._t("default",[_vm._v(_vm._s(_vm.content))])],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }